/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreasRequest
 */
export interface BulkDeleteFacilityServiceAreasRequest {
    /**
     * 
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreasRequest(value: object): value is BulkDeleteFacilityServiceAreasRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function BulkDeleteFacilityServiceAreasRequestFromJSON(json: any): BulkDeleteFacilityServiceAreasRequest {
    return BulkDeleteFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreasRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function BulkDeleteFacilityServiceAreasRequestToJSON(json: any): BulkDeleteFacilityServiceAreasRequest {
    return BulkDeleteFacilityServiceAreasRequestToJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasRequestToJSONTyped(value?: BulkDeleteFacilityServiceAreasRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

